import React, { useEffect, useCallback, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { ViewLoading } from "../loading";
import { _checkAuth, _user } from "../../apis/auth";
import { MainContext } from "../../context/main";

const MeaAuth = () => {
  const location = useLocation();
  const history = useHistory();
  const mainContext = useContext(MainContext);
  const { setuserInfo } = mainContext;

  const _checkUser = useCallback(
    async (token: any) => {
      if (typeof token === "string") {
        const resultCheckAuth = await _checkAuth(token);
        if (resultCheckAuth && resultCheckAuth.token) {
          const rsUserInfo = await _user(resultCheckAuth.user_id, token);
          if (rsUserInfo && rsUserInfo.data) {
            setuserInfo({
              id: resultCheckAuth.user_id,
              email: rsUserInfo.data[0].email,
              first_name: rsUserInfo.data[0].first_name,
              last_name: rsUserInfo.data[0].last_name,
              profile_picture: rsUserInfo.data[0].profile_picture,
              role: resultCheckAuth.user_role,
              mea: rsUserInfo.data[0].mea,
            });
            localStorage.setItem("token", token);
            setTimeout(() => {
              history.replace("/app");
            }, 1000);
          } else {
            history.replace("/auth/signin");
          }
        } else {
          history.replace("/auth/signin");
        }
      } else {
        history.replace("/auth/signin");
      }
    },
    [setuserInfo, history]
  );

  useEffect(() => {
    const searchText = location.search;
    const tokenParam = new URLSearchParams(searchText).get("token");

    _checkUser(tokenParam);
    return () => {};
  }, [location, _checkUser]);
  return <ViewLoading />;
};

export default MeaAuth;
